import { render, staticRenderFns } from "./GastroAnamnesiFisiologicaView.vue?vue&type=template&id=cd10a4ec"
import script from "./GastroAnamnesiFisiologicaView.vue?vue&type=script&lang=js"
export * from "./GastroAnamnesiFisiologicaView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports